import { graphql } from 'src/graphql';

import { ProjectFields } from 'src/fragments/projectFields.fragment';

export const FetchProjectById = graphql(
  `
    query FetchProjectById($id: ID) {
      projectByID(id: $id) {
        ...ProjectFields
      }
    }
  `,
  [ProjectFields],
);
